import { PureLightTheme } from "../../../styles/theme"

export const GridMain = {
    justifyContent: 'flex-end',
    [PureLightTheme.breakpoints.down('lg')]: {
        justifyContent: 'center',
    },
    '@media (max-width: 1110px)': {
        padding: '0px 30px 50px 30px',
    },
}

export const GridGuestWelcome = {
    paddingTop: '24px', 
    minWidth: 0,
    '@media (max-width: 1110px)': {
        paddingTop: '0px',
    },
}

export const GridForms = {
    paddingTop: '82px',
    minWidth: 0,
    flexBasis: 360,
    '@media (max-width: 1110px)': {
        paddingTop: '0px',
        paddingBottom: '50px',
    },
}